import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Typography, Link } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Header from "../components/general/Header";
import theme from "../ColorsConfig";

function Copyright() {
  let env = String();
  if (process.env.REACT_APP_ENVIRONMENT !== "production") {
    env = process.env.REACT_APP_ENVIRONMENT;
  }
  return (
    <Typography variant="body2" color="#FFF" align="center">
      {"Copyright © Divergentes"}
      {` ${new Date().getFullYear()}`}
    </Typography>
  );
}

export default function BasePage(props) {
  //   const [content] = props.content;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));
  const [title, setTitle] = useState("?????");

  useEffect(() => {
    if (props.title) {
      setTitle(props.title);
    }
  }, [props.title]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          minHeight: { xs: "70vh", sm: "100vh" },
        }}
      >
        <CssBaseline />
        {/*
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        >
          {isSmUp ? null : (
            <Navigator
              PaperProps={{ style: { width: drawerWidth } }}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            />
          )}

          <Navigator
            PaperProps={{ style: { width: drawerWidth } }}
            sx={{ display: { sm: "block", xs: "none" } }}
          />
        </Box> */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Header
            onDrawerToggle={handleDrawerToggle}
            title={title}
            showBack={props.showBack}
          />
          <Box
            component="main"
            sx={{
              backgroundImage:
                "url('https://images.clickfunnels.com/images/purple-geo.png')",
              backgroundSize: "cover",
              height: { xs: "80vh", sm: "90vh", md: "88vh" },
              overflow: "auto",
            }}
          >
            {props.children}
          </Box>
          {isSmUp && (
            <Box
              component="footer"
              sx={{ p: 2, bgcolor: "primary.main", height: "6vh" }}
            >
              <Copyright />
            </Box>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
